import { useUnistyles } from "react-native-unistyles";
import { View } from "@src/components";
import { Icon } from "@src/components/Icon";
import { sizes } from "@src/constants/sizes";
import { Breadcrumbs } from "./Breadcrumbs.web";
import { NavPressable } from "@src/components/NavPressable";
import { CameraSearchBar } from "./CameraSearchBar.web";

export function WebHeader() {
  const { theme } = useUnistyles();

  return (
    <View
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      height={sizes.webHeaderHeight}
      style={{
        paddingVertical: 20,
        paddingHorizontal: 28,
        borderBottomWidth: 0.5,
        borderBottomColor: theme.colors.borderCard,
        zIndex: 100,
        overflow: "visible",
      }}
    >
      {/* Left side: Breadcrumbs */}
      <View flexDirection="row" alignItems="center" flex={1}>
        <Breadcrumbs />
      </View>

      <View flexDirection="row" alignItems="center" gap="5xl">
        <CameraSearchBar />

        {/* Right side: Notifications */}
        <NavPressable href={"/activity"}>
          <Icon name="bellOutline" size={20} color={theme.colors.icon} />
        </NavPressable>
      </View>
    </View>
  );
}
